module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_bird-bd644a2247987843cae41364bed28c52.png";